import Http from './http'

export const get = (clientId) => Http.get(`/activities/${clientId}`)
export const getJson = (activityId) => Http.get(`/getJSON/${activityId}`)
export const saveJson = (data) => Http.post("/saveJSON", data)

export default {
  get,
  getJson,
  saveJson
}